export function parseDataType(dataType: string): string[] {
  const dataTypesA = dataType.split("_");
  if (dataTypesA.length > 1) {
    //TODO init the phone number select with data from b/e and review in general support for telephone number data type
    return ["number", dataTypesA[1]];
  }
  return [dataTypesA[0], ""];
}

//https://stackoverflow.com/questions/3115150/how-to-escape-regular-expression-special-characters-using-javascript
function escapeRegExp(text: string): string {
  // return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  return text.replace(/[\()*+?.,\\^$|\s]/g, "\\$&");
}

function buildValidationRegexp(validationPattern: string): string {
  let res = "",
    sizeNumbers = 0;

  function checkGroup(): void {
    if (sizeNumbers > 0) {
      res += "[0-9]{" + sizeNumbers + "}";
      sizeNumbers = 0;
    }
  }

  for (let i = 0, len = validationPattern.length; i < len; i++) {
    if (validationPattern.charAt(i) != "#") {
      checkGroup();
      res += validationPattern.charAt(i);
    } else {
      sizeNumbers++;
    }
  }
  checkGroup();
  // log.info(escapeRegExp(res));
  return escapeRegExp(res);
}

export function buildValidationRegExpFromServerPattern(
  validationPattern: string,
  dataType: string
): string | undefined {
  switch (dataType) {
    case "tel":
      return "^\\s*(\\+?\\s*\\d{1,4})?\\s*[.\\-/]?\\s*\\d{2,4}\\s*[.\\-/]?\\s*\\d{4,10}\\s*$";
    default:
      return validationPattern
        ? buildValidationRegexp(validationPattern)
        : undefined;
  }
}

/**********************************************************
 *
 * START OF UPLOAD RELATED METHODS
 *
 *********************************************************/

export function isImageMimeType(mimeType: string): boolean {
  const previewableImages = [
    "image/jpg",
    "image/jpeg",
    "image/gif",
    "image/png",
  ];
  return previewableImages.indexOf(mimeType) !== -1;
}

export function storeFile(backendURL: string, fileId: string, chatId: number): Promise<any> {
  return fetch(backendURL,
    {
      method : 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      // eslint-disable-next-line @typescript-eslint/camelcase
      body: JSON.stringify({f_id : fileId, chat_id: chatId}),
      headers : { 'Content-Type' : 'application/json'}
    });
}